(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const smooth = reduceMotion ? 'auto' : 'smooth';

  const nativeButton = () =>
    [...document.querySelectorAll('product-form button[name="add"], product-form .product-form__submit')].find(
      (button) => !button.closest('[data-ot3-mobile-buybar]')
    );

  const returnToPicker = () => {
    const target = document.querySelector('#ot3-product-buy .ot3-variant-group, #ot3-product-buy');
    target?.scrollIntoView({ behavior: smooth, block: 'center' });
    target?.querySelector('input:not(:disabled)')?.focus({ preventScroll: true });
  };

  const optionInputs = (kind) =>
    [...document.querySelectorAll(`#ot3-product-buy input[data-ot3-option-kind="${kind}"]`)];

  const isSingleValue = (value = '') => value.toLowerCase().includes('single');
  const isBlackValue = (value = '') => /sort|black/.test(value.toLowerCase());
  const isWhiteValue = (value = '') => /hvid|white/.test(value.toLowerCase());

  const selectVariant = (model, color) => {
    const modelInput = optionInputs('model').find((input) => {
      const value = input.value.toLowerCase();
      return model === 'single' ? value.includes('single') : value.includes('dual');
    });
    if (!modelInput || modelInput.disabled) return false;

    if (!modelInput.checked) modelInput.click();
    window.setTimeout(() => {
      syncVariantConstraints();
      const colorInput = optionInputs('color').find((input) =>
        color === 'black' ? isBlackValue(input.value) : isWhiteValue(input.value)
      );
      if (colorInput && !colorInput.disabled && !colorInput.checked) colorInput.click();
    }, 90);
    return true;
  };

  const syncVariantConstraints = () => {
    const model = optionInputs('model').find((input) => input.checked);
    const singleSelected = Boolean(model && isSingleValue(model.value));
    const colorInputs = optionInputs('color');
    const black = colorInputs.find((input) => isBlackValue(input.value));
    const white = colorInputs.find((input) => isWhiteValue(input.value));

    colorInputs.forEach((input) => {
      const hidden = singleSelected && isBlackValue(input.value);
      const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      input.closest('.ot3-variant-group--color')?.classList.toggle('is-ot3-single-model', singleSelected);
      if (label) {
        label.hidden = hidden;
        label.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      }
      input.disabled = hidden || input.classList.contains('disabled');
    });

    if (singleSelected && black?.checked && white && !white.disabled) white.click();
  };

  document.addEventListener(
    'click',
    (event) => {
      const label = event.target.closest('label[data-ot3-option-kind="model"]');
      if (!label || !isSingleValue(label.dataset.ot3OptionValue)) return;
      const black = optionInputs('color').find((input) => input.checked && isBlackValue(input.value));
      const white = optionInputs('color').find((input) => isWhiteValue(input.value));
      if (black && white && !white.disabled) white.click();
    },
    true
  );

  document.addEventListener('click', (event) => {
    const headerAdd = event.target.closest('[data-ot3-header-add]');
    if (headerAdd) {
      event.preventDefault();
      const button = nativeButton();
      if (!button || button.disabled) returnToPicker();
      else button.click();
      document.querySelector('details[open] > summary')?.click();
      return;
    }

    const modelChoice = event.target.closest('[data-ot3-select-model]');
    if (modelChoice) {
      event.preventDefault();
      const wanted = modelChoice.dataset.ot3SelectModel.toLowerCase();
      const input = [...document.querySelectorAll('.ot3-variant-group--model input[type="radio"]')].find((radio) =>
        radio.value.toLowerCase().includes(wanted)
      );
      if (input && !input.disabled) {
        input.click();
        window.setTimeout(returnToPicker, 180);
      } else returnToPicker();
    }
  });

  const initStickyDetails = () => {
    const bar = document.querySelector('[data-ot3-mobile-buybar]');
    /*
     * Use a versioned, feature-specific guard. Earlier revisions and the base
     * theme can leave data-ot3-uplift-ready on the element before this bundle
     * runs, which used to skip the switch-menu listeners entirely.
     */
    if (!bar || bar.dataset.ot3StickyReadyV4 === 'true') return;
    bar.dataset.ot3StickyReadyV4 = 'true';
    const selection = bar.querySelector('[data-ot3-mobile-selection]');
    const price = bar.querySelector('[data-ot3-mobile-price]');
    const image = bar.querySelector('.ot3-mobile-buybar__image img');
    const changeButton = bar.querySelector('[data-ot3-sticky-change]');
    const variantMenu = bar.querySelector('[data-ot3-sticky-variants]');
    const closeButton = bar.querySelector('[data-ot3-sticky-close]');
    const variantButtons = [...bar.querySelectorAll('[data-ot3-sticky-variant]')];
    const variantList = bar.querySelector('.ot3-sticky-variants__list');

    const stickyVariantOrder = new Map([
      ['single:white', 0],
      ['dual:white', 1],
      ['dual:black', 2],
    ]);
    variantButtons
      .sort((first, second) => {
        const firstKey = `${first.dataset.ot3StickyModel}:${first.dataset.ot3StickyColor}`;
        const secondKey = `${second.dataset.ot3StickyModel}:${second.dataset.ot3StickyColor}`;
        return (stickyVariantOrder.get(firstKey) ?? 99) - (stickyVariantOrder.get(secondKey) ?? 99);
      })
      .forEach((button) => variantList?.appendChild(button));

    const menuIsOpen = () => Boolean(variantMenu && !variantMenu.hasAttribute('hidden'));

    const closeMenu = () => {
      if (!variantMenu || !menuIsOpen()) return;
      variantMenu.setAttribute('hidden', '');
      changeButton?.setAttribute('aria-expanded', 'false');
      bar.classList.remove('is-switching');
    };

    const openMenu = () => {
      if (!variantMenu) return;
      variantMenu.removeAttribute('hidden');
      changeButton?.setAttribute('aria-expanded', 'true');
      bar.classList.add('is-switching');
      window.requestAnimationFrame(() => {
        variantMenu.querySelector('[aria-current="true"]')?.scrollIntoView({ block: 'nearest' });
      });
    };

    const syncStickyState = () => {
      const drawerOpen = document.body.classList.contains('ot3-cart-drawer-open');
      document.body.classList.toggle(
        'ot3-sticky-buy-visible',
        !bar.classList.contains('is-hidden') && !bar.classList.contains('is-footer-near') && !drawerOpen
      );
    };

    const sync = () => {
      const selected = [...document.querySelectorAll('#ot3-product-buy input[data-ot3-option-kind]:checked')]
        .map((input) => input.value)
        .join(' · ');
      if (selection && selected) selection.textContent = selected;

      const currentPrice = document.querySelector('#ot3-product-buy [data-ot3-current-price]');
      if (price && currentPrice?.textContent.trim()) price.textContent = currentPrice.textContent.trim();

      const activeMedia = document.querySelector('.product__media-item.is-active img');
      if (image && activeMedia?.currentSrc) image.src = activeMedia.currentSrc;

      const selectedModel = optionInputs('model').find((input) => input.checked)?.value || '';
      const selectedColor = optionInputs('color').find((input) => input.checked)?.value || '';
      variantButtons.forEach((button) => {
        const modelMatches = button.dataset.ot3StickyModel === (isSingleValue(selectedModel) ? 'single' : 'dual');
        const colorMatches = button.dataset.ot3StickyColor === (isBlackValue(selectedColor) ? 'black' : 'white');
        const active = modelMatches && colorMatches;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    };

    /*
     * Bind directly to the switch control and stop other sticky-bar handlers.
     * The theme's original buybar listener may otherwise treat the click as a
     * purchase action before the variant menu gets a chance to open.
     */
    const toggleVariantMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (menuIsOpen()) closeMenu();
      else openMenu();
    };

    /*
     * Open on pointerdown so the switcher wins before the base theme's
     * click-to-buy delegation. Preventing the pointer default also suppresses
     * the synthetic click that would otherwise immediately close the menu.
     */
    changeButton?.addEventListener('pointerdown', toggleVariantMenu, true);
    changeButton?.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        toggleVariantMenu(event);
      },
      true
    );
    changeButton?.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true
    );
    closeButton?.addEventListener('click', closeMenu);
    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        selectVariant(button.dataset.ot3StickyModel, button.dataset.ot3StickyColor);
        closeMenu();
        window.setTimeout(sync, 180);
      });
    });
    document.addEventListener('click', (event) => {
      if (menuIsOpen() && !bar.contains(event.target)) closeMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menuIsOpen()) {
        closeMenu();
        changeButton?.focus();
      }
    });

    const footer = document.querySelector('#shopify-section-footer, footer, .footer');
    if (footer) {
      let footerFrame = 0;
      const syncFooterState = () => {
        footerFrame = 0;
        /*
         * Keep the bar hidden from shortly before the footer begins and for
         * the entire remainder of the page. IntersectionObserver alone would
         * show it again after the footer's top edge left the viewport.
         */
        const footerIsNear = footer.getBoundingClientRect().top <= window.innerHeight - 120;
        bar.classList.toggle('is-footer-near', footerIsNear);
        if (footerIsNear) closeMenu();
        syncStickyState();
      };
      const queueFooterSync = () => {
        if (footerFrame) return;
        footerFrame = window.requestAnimationFrame(syncFooterState);
      };
      window.addEventListener('scroll', queueFooterSync, { passive: true });
      window.addEventListener('resize', queueFooterSync);
      syncFooterState();
    }

    const scope = document.querySelector('#ot3-product-buy, .product__info-container');
    if (scope && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(scope, { subtree: true, childList: true, attributes: true, characterData: true });
      new MutationObserver(syncStickyState).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('change', (event) => {
      if (event.target.closest('#ot3-product-buy')) {
        window.setTimeout(() => {
          syncVariantConstraints();
          sync();
        }, 100);
      }
    });
    syncVariantConstraints();
    sync();
    syncStickyState();
  };

  const initVideoViewer = () => {
    /*
     * Grid-videoerne er rene previews: native controls (progressbjælke,
     * menu, play) fjernes, så play-knappen er tilens eneste overlay.
     * Den store viewer sætter selv controls på sin klon.
     */
    document.querySelectorAll('.ot3-product-video-grid__item video').forEach((video) => {
      video.removeAttribute('controls');
    });

    const expandButtons = [...document.querySelectorAll('[data-ot3-video-expand]')];
    if (!expandButtons.length || document.querySelector('[data-ot3-video-viewer]')) return;

    const viewer = document.createElement('div');
    viewer.className = 'ot3-video-viewer';
    viewer.dataset.ot3VideoViewer = '';
    viewer.hidden = true;
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Produktvideo');
    viewer.innerHTML = `
      <div class="ot3-video-viewer__panel">
        <button class="ot3-video-viewer__close" type="button" aria-label="Luk video">×</button>
        <div class="ot3-video-viewer__slot"></div>
      </div>`;
    document.body.appendChild(viewer);

    const slot = viewer.querySelector('.ot3-video-viewer__slot');
    const closeButton = viewer.querySelector('.ot3-video-viewer__close');
    let trigger = null;

    const close = () => {
      const video = slot.querySelector('video');
      video?.pause();
      slot.replaceChildren();
      viewer.hidden = true;
      document.body.classList.remove('ot3-video-viewer-open');
      trigger?.focus();
      trigger = null;
    };

    expandButtons.forEach((button) => {
      if (button.dataset.ot3VideoReady) return;
      button.dataset.ot3VideoReady = 'true';
      button.addEventListener('click', () => {
        const source = button.closest('.ot3-product-video-grid__item')?.querySelector('video');
        if (!source) return;
        const clone = source.cloneNode(true);
        clone.controls = true;
        clone.playsInline = true;
        clone.muted = false;
        clone.currentTime = source.currentTime || 0;
        source.pause();
        slot.replaceChildren(clone);
        trigger = button;
        viewer.hidden = false;
        document.body.classList.add('ot3-video-viewer-open');
        closeButton.focus();
        clone.play().catch(() => {});
      });
    });

    closeButton.addEventListener('click', close);
    viewer.addEventListener('click', (event) => {
      if (event.target === viewer) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !viewer.hidden) close();
    });
  };

  const initDrawerState = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    const sync = () => {
      const open = drawer.classList.contains('active');
      document.body.classList.toggle('ot3-cart-drawer-open', open);
      const sticky = document.querySelector('[data-ot3-mobile-buybar]');
      if (sticky) sticky.setAttribute('aria-hidden', open ? 'true' : 'false');
      document.body.classList.toggle(
        'ot3-sticky-buy-visible',
        Boolean(sticky) && !open && !sticky.classList.contains('is-hidden') && !sticky.classList.contains('is-footer-near')
      );
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  };

  initStickyDetails();
  syncVariantConstraints();
  initVideoViewer();
  initDrawerState();
  document.addEventListener('shopify:section:load', () => {
    initStickyDetails();
    syncVariantConstraints();
    initVideoViewer();
  });
})();

/*
 * Produkt-handlinger: "Del" og "Stil et spørgsmål".
 * Dialogerne er native <dialog>, så fokusfælde, Escape og
 * baggrundsinaktivering kommer fra browseren. Herunder ligger kun
 * åbn/luk, kopiér-link og den valgfrie native delefunktion.
 */
(() => {
  const dialogFor = (id) => document.getElementById(id);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ot3-dialog-open]');
    if (opener) {
      const dialog = dialogFor(opener.dataset.ot3DialogOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest('[data-ot3-dialog-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    const copyButton = event.target.closest('[data-ot3-copy]');
    if (copyButton) {
      const input = document.getElementById(copyButton.dataset.ot3Copy);
      const status = copyButton.closest('.ot3-dialog__panel')?.querySelector('[data-ot3-copy-status]');
      if (!input) return;
      const done = () => { if (status) status.textContent = 'Linket er kopieret.'; };
      const fail = () => { if (status) status.textContent = 'Kunne ikke kopiere – markér linket og kopiér manuelt.'; };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(input.value).then(done).catch(fail);
      } else {
        input.select();
        try { document.execCommand('copy') ? done() : fail(); } catch (error) { fail(); }
      }
      return;
    }

    const nativeShare = event.target.closest('[data-ot3-native-share]');
    if (nativeShare && navigator.share) {
      navigator.share({ url: nativeShare.dataset.ot3NativeShare, title: document.title }).catch(() => {});
    }
  });

  /* Klik på baggrunden lukker dialogen. */
  document.addEventListener('click', (event) => {
    if (event.target.tagName !== 'DIALOG' || !event.target.open) return;
    const box = event.target.getBoundingClientRect();
    const outside =
      event.clientX < box.left || event.clientX > box.right ||
      event.clientY < box.top || event.clientY > box.bottom;
    if (outside) event.target.close();
  });

  /* Vis kun "Del via enhed", hvor browseren faktisk understøtter det. */
  if (navigator.share) {
    document.querySelectorAll('[data-ot3-native-share]').forEach((button) => {
      button.hidden = false;
    });
  }
})();
